import { PerkList, TitleDuoTone } from '@fff-web/fff-ui-shared';
import { useUpgradeMembershipContext } from '../../../../utils/ContextProviders/UpgradeContext';
import * as styles from './OneMillionContainer.module.scss';

const title = {
  text: 'See Why Over 1 Million Members Trust Us',
  textToChangeColor: '1 Million Members',
  color: '#fb6a66',
};

const OneMillionContainer = () => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const variables = growthUpgrade.variables;
  const { text, textToChangeColor } = title;
  const perkList = variables.overMillionSection?.perkList || [];
  return (
    <section className={styles.wrapper}>
      <TitleDuoTone textToChangeColor={textToChangeColor} text={text} />
      <PerkList list={perkList} />
    </section>
  );
};

export { OneMillionContainer, title };
